import React, { Component, Fragment } from 'react'
import { Button, TextInput, Checkbox, Loading } from 'carbon-components-react'
import UpdatePasswordAPI from '../api/UpdatePasswordAPI'
import PropTypes from 'prop-types'
import ErrorMessageIcon from '../../globals/images/icon-error-message.svg'
import { emailRegEx } from '../../utils/regExpressionsUtils'
import { trackEventMessage, trackEventMessageFailure } from '../../TelemetryService'
import { EventModel } from '../../models/EventModel'
import { PASSWORD_CHANGE } from './../../constants'
export default class UpdatePassword extends Component  {

    constructor() {
        super()
        this.state = {
            enableSubmit:false,
            email: '',
            termsAndCondition: false,
            error: '',
            serverError:'',
            loading: false
        }
        this.handleEmailValid = this.handleEmailValid.bind( this )
        this.handleSubmit = this.handleSubmit.bind( this )
        this.handleEmailOnChange = this.handleEmailOnChange.bind( this )
        this.handleChangeTermsCondition = this.handleChangeTermsCondition.bind( this )
    }

    get config() {
        return this.props.config || {}
    }

    get updatePasswordApiUrl() {
        return this.config.updatePasswordApiUrl || process.env.REACT_APP_UPDATE_PASSWORD_API_URL 
    }

    handleEmailValid = e => {
  
        if( emailRegEx.regEx.test(  e.target.value ) ) {
            this.setState( { error: null, email: e.target.value, serverError: null } )
            
            if ( this.state.termsAndCondition ) {
                this.setState( { enableSubmit: true,  error: null } )
            }

        }else{
            this.setState( { enableSubmit: false, error: emailRegEx.errorMsg, email : e.target.value } )
        }
        if( e.target.value == '' ){
            this.setState( { enableSubmit: false, error: null, email : e.target.value, serverError:null } )
        }
    }

    handleEmailOnChange = e => {
        this.setState( { email : e.target.value } )

        if( emailRegEx.regEx.test(  e.target.value ) && this.state.termsAndCondition ){
            this.setState( { enableSubmit: true,  error: null } )
        }else{
            this.setState( { enableSubmit: false } )
        }
        if( e.target.value == '' ){
            this.setState( { enableSubmit: false } )
        }
    }

    handleChangeTermsCondition = ( value, name, e ) => {
        this.setState( { termsAndCondition: value } )
        
        if( value &&  emailRegEx.regEx.test(  this.state.email ) ){
            this.setState( { enableSubmit: true,  error: null } )
        }else{
            this.setState( { enableSubmit: false } )
        }
    }

    handleSubmit = e =>{
        const { showConfirmation } = this.props
        const { email, error, enableSubmit } = this.state
        e.preventDefault()
        this.setState( { loading: true } )
        if( !error && enableSubmit ){
            UpdatePasswordAPI( {
                email: email,
                apiUrl: this.updatePasswordApiUrl
            } )
            .then( data => {
                trackEventMessage( new EventModel( PASSWORD_CHANGE.SUCCESS, email )  ) 
                showConfirmation( email )
            } )
            .catch( data => {
                trackEventMessageFailure( new EventModel( PASSWORD_CHANGE.FAILURE, email ),data ) 
                showConfirmation( email )
            } )
        }else{
            this.setState( { loading: false } )
        }

    }
    render() {
        const{ error, serverError, loading, email, termsAndCondition, enableSubmit } = this.state
        const title = 'Update password'
        const message =`We recognize this as your first time logging into this site (eversource.com). We'll need you to update your password to continue.
                        Note: all your account settings such as auto pay or paperless billing stay the same. You can manage your profile and settings after logging in.`
        const ariaMessage = title +'. '+ message
        return (
            <Fragment>
                <main className="c-main forgot-password">
                    <div className="os-container--max-width">
                        <div className="c-form-card">
                            <div className="c-form-card__container" tabIndex={ 0 }>
                                <h1 className="o-heading-alpha u-heading-alpha--overrides" tabIndex={ 0 } >{ title }</h1>
                                
                                <form onSubmit = { this.handleSubmit }>
                                    <p className="u-type-size-2 mb-6" tabIndex={ 0 }>We recognize this as your first time logging into this site (eversource.com). We'll need you to update your password to continue.</p>
                                    <p className="u-type-size-2 mb-5" tabIndex={ 0 }>Note: all your account settings such as auto pay or paperless billing stay the same. You can manage your profile and settings after logging in.</p>
                                    <div className="form-group-forgot-password mb-4">
                                        <TextInput 
                                        labelText="Confirm Email" 
                                        className="form-input-forgot-password" 
                                        id="Email" 
                                        type="text" 
                                        autoComplete="false"
                                        invalidText= { error }
                                        invalid={ error ? true : false } 
                                        tabIndex={ 0 }
                                        maxLength="79"
                                        value={ email } 
                                        onBlur={ this.handleEmailValid }
                                        onChange={ this.handleEmailOnChange }
                                        aria-label={ 'Enter Email field' +'. '+ ariaMessage }
                                        autoFocus={ true } />
                                    </div>
                                    {
                                    serverError ? 
                                        <div className="c-form-error-message">                                            
                                            <img src={ ErrorMessageIcon } alt="Message Error" className="svg-form-error-message"/>
                                            <p> { serverError } </p>
                                        </div>
                                    : null
                                    }
                                    <Checkbox labelText={ 
                                        <label className="u-type-size-2 u-text--dark-grey">
                                            By checking this box, you acknowledge that you have read and agree to the Eversource 
                                            <a href="/Security/Account/ViewTermsandConditions" target="_blank" className="c-link">Terms and Conditions</a>
                                        </label> } 
                                        checked={ termsAndCondition } 
                                        data-testid="TermsAndConditionTestID" 
                                        id="TermsAndConditionID" 
                                        className="mb-7" onChange={ this.handleChangeTermsCondition } />
                                    {
                                        loading ?
                                            <Loading
                                            description= { null } className="center-spinner" withOverlay={ false } small = { true }
                                            />
                                            :
                                            <Button   
                                            className={ ` ${ enableSubmit ? 'c-btn c-btn--primary c-btn--center-aligned' : 'c-btn c-btn--disabled c-btn--center-aligned' } mb-3` } 
                                            type="submit"
                                            tabIndex={ 0 }
                                            aria-label={ `Submit ${ enableSubmit ? 'Enabled' : 'Disabled' } ` }
                                            data-testid="btn-Submit">
                                                Submit
                                            </Button>
                                    }
                                     
                                </form>
                            </div>
                        </div>
                    </div>
                </main>
            </Fragment>
        )
    }
}

UpdatePassword.propTypes = {
    showConfirmation: PropTypes.func.isRequired,
    config: PropTypes.shape( {
        updatePasswordApiUrl: PropTypes.string
    } )
}
